
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/SupabaseAuthContext';
import { clearUserSession } from '@/utils/sessionManager';

export const useHeaderAuth = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    
    try {
      // Clear local session data first
      clearUserSession();
      
      // Call Supabase signOut
      await signOut();
      
      // Force redirect to auth page
      window.location.href = '/auth';
    } catch (error) {
      console.error('Error during logout:', error);
      
      // Still clear the session on error
      clearUserSession();
      
      // Still redirect to ensure logout happens
      window.location.href = '/auth';
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleLogout
  };
};
